import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import * as CredentialsActions from './credentials.actions';

export const credentialsFeatureKey = 'credentials';

export interface State {
    maps: {
        apiKey: string;
        loaded: boolean;
    };
}

export const initialState: State = {
    maps: {
        apiKey: '',
        loaded: false,
    },
};

export const reducer = createImmerReducer(
    initialState,

    on(CredentialsActions.mapsApiLoaded, (state) => {
        state.maps.loaded = true;
        return state;
    }),
    on(CredentialsActions.setMapsApiKey, (state, { apiKey }) => {
        state.maps.apiKey = apiKey;
        return state;
    })
);
